import * as React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import {useEffect} from 'react';
import {getAcceptorBranches} from '../../redux/actions/acceptors';
import {acceptorBranchesSelector, acceptorsByIdSelector, acceptorsListSelector} from '../../redux/selectors/acceptors';
import {Route, useNavigation} from '@react-navigation/native';
import {useIsDesktop} from '../../shared/hooks/useIsDesktop';
import {getFormValues} from 'redux-form';
import {Forms} from '../../shared/models/forms';
import {Screens} from '../../shared/routing';
import {useAcceptorsResolver} from '../../shared/resolvers/acceptorsResolver';
import {acceptorsSlice} from '../../redux/reducers/acceptors';

export const LoyaltyProgramAcceptorScreen = ({route}: {route: Route<string>}) => {
  useAcceptorsResolver();
  //@ts-ignore
  const id = route.params?.id;
  const dispatch = useAppDispatch();
  const acceptors = useSelector(acceptorsListSelector());
  const acceptor = useSelector(acceptorsByIdSelector(+id));
  const acceptorBranches = useSelector(acceptorBranchesSelector());
  const isDesktop = useIsDesktop();
  const filterFormValues = useSelector(getFormValues(Forms.acceptorsFilterForm));
  const navigation = useNavigation();
  const [filter, setFilter] = React.useState({});

  useEffect(() => {
    if (acceptors && id) {
      if (acceptors?.find((item) => item.id === +id) === undefined) {
        (navigation.navigate as any)(Screens.MainTabs, {
          screen: Screens.CardServicesMenu,
          params: {screen: Screens.LoyaltyProgram},
        });
      }
    }
  }, [acceptors, id]);

  useEffect(() => {
    if (!acceptorBranches) {
      dispatch(getAcceptorBranches(id));
      return;
    }

    return () => {
      dispatch(acceptorsSlice.actions.setAcceptorBranches(null));
    };
  }, [id, acceptorBranches]);

  useEffect(() => {
    if (!acceptor) return;
    navigation.setOptions({title: acceptor.name?.trim() || 'Партнёр'});
  }, [acceptor, navigation]);

  React.useEffect(() => {
    if (filterFormValues && !isDesktop) {
      setFilter(filterFormValues);
    }
  }, [filterFormValues, isDesktop]);

  return (
    <View acceptor={acceptor} acceptorBranches={acceptorBranches} filter={filter} onFilterApply={setFilter} id={id} />
  );
};
